/**
 * shallowEqual that supports primitives, objects and arrays in an order-insensitive manner
 * Objects are not evaluated recursively
 */
export function shallowEqual<T extends Object | undefined | null>(a: T, b: T) {
  // Takes care of primitive types and references of objects and functions
  if (a === b) return true;

  // If one of the values is null, they are not equal (null !== undefined and typeof null === 'object')
  if (a === null || b === null) return false;

  // If we don't have simple equality, they can only be equal if we have two objects
  if (typeof a !== 'object' || typeof b !== 'object') return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  // Also covers arrays with different lengths
  if (keysA.length !== keysB.length) return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    const valuesA = new Set(a);
    for (const valueB of b) {
      if (!valuesA.has(valueB)) return false;
    }
    return true;
  }

  for (let i = 0; i < keysA.length; i++) {
    if ((a as any)[keysA[i]] !== (b as any)[keysA[i]]) return false;
  }

  return true;
}
